<div class="entities">
  <div class="entities-head">
    <h2 class="entities-title">
      <i class="pi pi-building"></i>
      <span>{{ "تصفح الجهات" | translator }}</span>
    </h2>

    <div class="entities-tools">
      <div class="entities-tabs">
        <button type="button" class="entities-tab" [class.active]="entitytype === 'all'" (click)="applyTypeFilter('all')">
          {{ "All entities and ministries" | translator }}
        </button>
        <button type="button" *ngFor="let type of uniqueTypeNames" class="entities-tab"
          [class.active]="entitytype === type" (click)="applyTypeFilter(type)">
          {{ type }}
        </button>
        <ng-container *ngIf="skelition">
          <span class="skeleton entities-tab-skeleton"></span>
          <span class="skeleton entities-tab-skeleton"></span>
        </ng-container>
      </div>

      <label class="entities-search">
        <input type="text" [(ngModel)]="searchQuery" (ngModelChange)="applyFilters()"
          placeholder="{{ 'Search for entities and ministries' | translator }}" />
        <i class="pi pi-search"></i>
      </label>
    </div>
  </div>

  <div *ngIf="skelition" class="entities-grid" aria-busy="true">
    <div *ngFor="let _ of skeletonCards" class="entity-card entity-card-skeleton">
      <div class="entity-face">
        <span class="skeleton entity-logo-skeleton"></span>
        <span class="skeleton entity-name-skeleton"></span>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!skelition">
    <div class="entities-grid">
      <ng-container *ngFor="let entity of visibleData">
        <ng-container *ngTemplateOutlet="card; context: { $implicit: entity, child: false }"></ng-container>

        <div *ngIf="showChildren && current?._id === entity._id && currentChildren.length" class="entities-children">
          <ng-container *ngFor="let child of currentChildren">
            <ng-container *ngTemplateOutlet="card; context: { $implicit: child, child: true }"></ng-container>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <p *ngIf="filteredData.length === 0" class="entities-empty">{{ "لا توجد نتائج" | translator }}</p>

    <div *ngIf="filteredData.length > visibleCount" class="entities-more">
      <button type="button" class="entities-more-btn" (click)="visibleCount = visibleCount + pageSize">
        <span>{{ "عرض المزيد" | translator }}</span>
        <i class="pi pi-angle-down"></i>
      </button>
    </div>
  </ng-container>
</div>

<ng-template #card let-entity let-child="child">
  <div class="entity-card" [class.child]="child" [class.selected]="!child && current?._id === entity._id && showChildren"
    role="button" tabindex="0" (click)="handleClick(child, entity)" (keydown.enter)="handleClick(child, entity)">

    <span *ngIf="!child && getWithService(entity.children ?? []).length > 0" class="entity-subs"
      pTooltip="{{ 'this entity has sub divisions' | translator }}" tooltipPosition="top">
      <i class="pi pi-sitemap"></i>
      <span>{{ getWithService(entity.children ?? []).length }}</span>
    </span>

    <div class="entity-face">
      <div class="entity-logo">
        <img *ngIf="checkisImg(entity?.image_sq); else iconLogo" src="{{ staticURL + entity.image_sq }}"
          [alt]="entity.name" loading="lazy" />
        <ng-template #iconLogo>
          <i class="pi pi-{{ entity?.image_sq }}"></i>
        </ng-template>
      </div>
      <div class="entity-name">{{ entity.name }}</div>
    </div>

    <div class="entity-hover"
      *ngIf="dataSorter(child ? (entity?.data_counter ?? []) : getDisplayCounter(entity), entity?._id) as counters"
      [class.compact]="counters.length > 3">
      <div class="entity-hover-name">{{ entity.name }}</div>
      <div class="entity-counter" *ngFor="let counter of counters">
        <i class="{{ counterIcon(counter) }}"></i>
        <span class="entity-counter-num">{{ counter?.count }}</span>
        <span class="entity-counter-label">{{ counterLabel(counter) }}</span>
      </div>
    </div>
  </div>
</ng-template>
